<template>
  <div class="Page Home">
    <h2 class="subtitle">
      Base de données des projets <version-notes :meta="meta" />
    </h2>
    <div class="media">
      <div
        data-name="supports-image"
        class="imagemap--wrapper"
        style="flex: 0 1 800px"
      >
        <img src="/bdd.png" />
        <span
          class="bullet"
          :class="index === highlight ? 'bullet--high' : ''"
          :data-name="`bullet-${index}`"
          v-for="(pin, index) in $options.pins"
          :key="index"
          :style="{ left: `${pin[0]}%`, top: `${pin[1]}%` }"
          >{{ index }}
        </span>
      </div>
      <div style="flex: 1 1 67ch; margin-left: 2em;">
        <p>
          La
          <hl @e="e(0)" @l="l" :h="0" :c="highlight">base de données</hl> vise à
          générer automatiquement la plupart des supports de communication de
          l'agence.
        </p>
        <p>Les supports proposés sont :</p>
        <ul>
          <li data-name="support-list-item fiches-a4">
            <hl @e="e(1)" @l="l" :h="1" :c="highlight" :r="1"
              >les fiches projet A4</hl
            >
          </li>
          <li data-name="support-list-item portfolio">
            <hl @e="e(2)" @l="l" :h="2" :c="highlight" :r="1"
              >le portfolio de l'agence</hl
            >
          </li>
          <li data-name="support-list-item index-textuel">
            <hl @e="e(3)" @l="l" :h="3" :c="highlight" :r="1"
              >l'index textuel des projets</hl
            >
          </li>
          <li data-name="support-list-item fiches-a3">
            <hl @e="e(4)" @l="l" :h="4" :c="highlight" :r="1"
              >les fiches projet A3</hl
            >
          </li>
          <li data-name="support-list-item index-visuel">
            <hl @e="e(5)" @l="l" :h="5" :c="highlight" :r="1"
              >l'index visuel des projets</hl
            >
          </li>
          <li data-name="support-list-item cv">
            <hl @e="e(6)" @l="l" :h="6" :c="highlight" :r="1"
              >les CV, pages de présentation</hl
            >
          </li>
          <li data-name="support-list-item dossier-presse">
            <hl @e="e(7)" @l="l" :h="7" :c="highlight" :r="1"
              >les dossiers de presse, papier et numérique</hl
            >
          </li>
          <li data-name="support-list-item site">
            <hl @e="e(8)" @l="l" :h="8" :c="highlight" :r="1"
              >le site web de l'agence</hl
            >
          </li>
        </ul>
        <p>
          L'objectif est de passer moins de temps à fabriquer ces supports, pour
          prendre plus de temps à travailler leur contenu. Ainsi, un projet
          entré une fois dans la base de données devient disponible pour
          s'incarner dans tous ces supports. Par exemple, corriger ou mettre à
          jour une fiche projet met à jour le site internet.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Hl from "./Highlight";
import meta from "./../../../package.json";
import VersionNotes from "./VersionNotes";

export default {
  name: "Home",
  components: { VersionNotes, Hl },
  data() {
    return {
      highlight: -1,
      meta
    };
  },
  methods: {
    e(d) {
      this.highlight = d;
    },
    l() {
      this.highlight = -1;
    }
  },
  pins: [
    [32, 30],
    [6, -2],
    [35, -3],
    [76, -2],
    [-2, 33.5],
    [74, 33],
    [7, 68],
    [36, 72],
    [76, 66]
  ]
};
</script>

<style lang="scss">
.Home {
  .imagemap--wrapper {
    position: relative;
    span {
      position: absolute;
      transform: translate3d(50%, 50%, 0);
    }
  }
  .subtitle {
    margin-bottom: 2em;
  }
  .bullet {
    background: #2e3192;
    color: white;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    font-weight: 700;
    display: inline-block;
    &--high {
      background: orangered;
    }
  }
  p {
    margin-bottom: 0.75em;
  }
  p .bullet,
  li .bullet {
    position: relative;
    top: -2px;
  }

  p strong {
    font-weight: 700;
  }

  ul {
    padding-left: 1em;
    margin-bottom: 0.75em;
  }
}
</style>
